import { render, staticRenderFns } from "./PershingInheritedIRA.vue?vue&type=template&id=69ce535b&scoped=true"
import script from "./PershingInheritedIRA.vue?vue&type=script&lang=js"
export * from "./PershingInheritedIRA.vue?vue&type=script&lang=js"
import style0 from "./PershingInheritedIRA.vue?vue&type=style&index=0&id=69ce535b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69ce535b",
  null
  
)

export default component.exports